<template>
  <div>
    <!-- 返回键 -->
    <div class="back" @click="back()">
      <i></i>
      <span>返回</span>
    </div>
    <!-- 卡片区域 -->
    <div class="card_box">
      <span class="card_box_span"
        ><h4>考试名称：{{ $parent.examInfo.ExamName }}</h4></span
      >
      <div class="card_box_item">
        <div class="card_img" v-for="(item, index) in imgArr" :key="index">
          <img :src="item.imgUrl" alt="" />
          <p>{{ item.text }}</p>
          <p>
            <span>{{ item.sum }}</span>
            <span class="text_sizi">{{ item.num }}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 表单部分 -->
    <div class="mian">
      <div class="mian_input">
        <el-form
          :model="formLabelAlign"
          ref="formLabelAlign"
          :label-position="labelPosition"
        >
          <el-form-item label="科室：" prop="department">
            <span></span>
            <el-select v-model="formLabelAlign.department" @change="queryChang">
              <el-option label="全部" value=""> </el-option>
              <el-option
                v-for="item in departmentArr"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职称：" prop="rank">
            <el-select v-model="formLabelAlign.rank" @change="queryChang">
              <el-option label=" 全部" value=""> </el-option>
              <!-- <el-option label="全部" value=""> </el-option> -->
              <el-option
                v-for="item in rankArr"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="考试状态：" prop="examState">
            <el-select v-model="formLabelAlign.examState" @change="queryChang">
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in examStateArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="考试成绩：" prop="examResults">
            <el-select
              v-model="formLabelAlign.examResults"
              @change="queryChang"
            >
              <el-option label="默认" value="0"></el-option>
              <el-option
                v-for="item in examResultsArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批阅状态：" prop="examines">
            <el-select v-model="formLabelAlign.examines" @change="queryChang">
              <el-option label="全部" value=""> </el-option>
              <el-option
                v-for="item in examinesArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交卷状态：" prop="saveModel">
            <el-select v-model="formLabelAlign.saveModel" @change="queryChang">
              <el-option label="全部" value=""> </el-option>
              <el-option
                v-for="item in saveModelArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="人脸识别结果：" prop="faceResult">
            <el-select v-model="formLabelAlign.faceResult" @change="queryChang">
              <el-option label="全部" value=""> </el-option>
              <el-option
                v-for="item in faceResultArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item class="ts">
            <!-- 右边搜索栏 -->
            <div class="search_btn">
              <div class="search_left">
                <el-input
                  v-model="formLabelAlign.account"
                  icon="el-icon-search"
                  placeholder="根据考生名称或账号进行搜索"
                ></el-input>
                <i class="iconfont icon-sousuo"></i>
              </div>
              <div class="query_btn">
                <el-button
                  icon="el-icon-search"
                  class="searchbtn"
                  @click="handleQuery"
                  >搜索</el-button
                >
                <el-button
                  icon="el-icon-refresh"
                  class="searchbtn sonbtn"
                  @click="resetForm('formLabelAlign')"
                  >重置</el-button
                >
              </div>
            </div>
          </el-form-item>
        </el-form>

        <!-- <div class="query_btn">

          <el-button
            icon="el-icon-refresh"
            class="searchbtn sonbtn"
            @click="resetForm('formLabelAlign')"
            >重置</el-button
          >
        </div> -->
      </div>
      <!-- 按钮操作 -->
      <div class="mian_btn">
        <el-button
          @click="
            dialogVisible = true;
            define = false;
          "
        >
          <i class="iconfont icon-yunduan"></i>一键发布成绩
        </el-button>
        <el-button :loading="btnLoading" @click="exportQuestions">
          <i class="iconfont icon-daochu"></i>导出答题详情
        </el-button>
        <el-button @click="exportResults">
          <i class="iconfont icon-daochu"></i>导出成绩
        </el-button>
      </div>
      <!-- 表格 -->
      <div class="mian_form" v-loading="loading">
        <el-table
          :data="getData"
          style="width: 100%"
          :cell-class-name="stateColor"
          :row-class-name="tableRowClassName"
          @selection-change="handleSelectionChange"
          :header-cell-style="{
            'background-color': '#8FCBFF',
            color: '#333333',
            height: '60px',
          }"
        >
          <!-- <el-table-column type="selection" width="80"></el-table-column> -->
          <el-table-column width="80" label="序号">
            <template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="UserName"
            label="考生名字"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="myusername"
            label="考生账号"
            :show-overflow-tooltip="true"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="DepartmentName" label="科室">
          </el-table-column>
          <el-table-column prop="PTitle" label="职称"> </el-table-column>
          <el-table-column prop="IP" label="IP记录" width="110px">
            <template slot-scope="scope">
              <p
                @click="userIP(scope.row)"
                :class="scope.row.IP != '--' ? 'bd' : ''"
              >
                {{ scope.row.loginipCount > 1 ? "多条IP记录" : scope.row.IP }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="AlreadyStuCount1"
            label="答题用时(分钟)"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="Score" label="考试成绩(分)">
            <template slot-scope="scope">
              {{ scope.row.Score }}
              <p
                v-if="
                  censusArr[0].IsSubjective == 1 &&
                  scope.row.IsRead == 0 &&
                  scope.row.Score !== '--'
                "
              >
                (未含主观题成绩)
              </p>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in formColumns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作"
            align="center"
            width="260"
          >
            <template slot-scope="scope">
              <div class="operation_box">
                <el-button
                  type="text"
                  size="small"
                  @click="heExam(scope.row)"
                  :disabled="isbtn(scope.row)"
                  >批阅试卷</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  :disabled="scope.row.IsPublish == 1 || scope.row.IsRead == 0"
                  @click="heResults(scope.row)"
                  >发布成绩</el-button
                >
                <el-button type="text" size="small" @click="examView(scope.row)"
                  >查看试卷</el-button
                >
                <!-- <el-button type="text" size="small" @click="ccc(scope.row)"
                  >测试查看</el-button
                > -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="foot_box">
        <div class="foot_pagetions">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="showpageindex"
            :page-size="pageSize"
            :page-sizes="pagesizesarr"
            layout="prev, pager, next,sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 成绩发布弹窗 -->
    <div class="everywhere">
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <div class="mode_view">
          <el-radio-group v-model="achievement">
            <el-radio :label="0">仅发布成绩</el-radio>
            <el-radio :label="1">发布成绩和答题详情</el-radio>
          </el-radio-group>
        </div>
        <p class="p">成绩一经发布将不得修改，确定发布吗？</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            v-if="define"
            :loading="sundflag"
            @click="releaseKey()"
          >
            确 定
          </el-button>
          <el-button
            type="primary"
            :loading="sundflag"
            v-else
            @click="dowmtest()"
          >
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
    <!-- IP弹窗 -->
    <div class="ip_view">
      <el-dialog
        title="IP记录"
        :visible.sync="PopupIP"
        width="30%"
        :close-on-click-modal="false"
      >
        <div class="ip_mian">
          <div class="exam_name">
            <p>考生姓名:{{ isRowName.RealName }}</p>
            <p>考生账号:{{ isRowName.UserName }}</p>
          </div>
          <p>用户在本次考试过程中进入考试的记录如下:</p>
          <el-table
            :data="getIPData"
            style="width: 100%"
            height="300"
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
            :header-cell-style="{
              'background-color': '#8FCBFF',
              color: '#333333',
              height: '60px',
            }"
          >
            <el-table-column
              type="index"
              width="80"
              label="序号"
            ></el-table-column>
            <el-table-column
              v-for="(item, index) in formIpData"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              height="150"
              label-height="50"
              align="center"
            >
            </el-table-column>
          </el-table>
          <!-- 小表格 -->
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="PopupIP = false">取 消</el-button>
          <el-button type="primary" @click="PopupIP = false"> 确 定 </el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 导出答题详情 -->
    <div class="exportView">
      <el-dialog
        title="温馨提示"
        :visible.sync="exportVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <div class="delete_mian">
          <p>
            导出成绩前请留意主观题是否完成批阅且发布成绩，成绩未发布的考试无法导出答题详情。后台需要几分钟来生成您需要的试卷文件，点击确认开始生成试卷文件。
          </p>
        </div>
        <p></p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="exportVisible = false">取 消</el-button>
          <el-button type="primary" @click="exportMine()"> 确 定 </el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 成绩发布记录条数弹窗 -->
    <div class="exportView">
      <el-dialog
        title="温馨提示"
        :visible.sync="recordNumView"
        width="30%"
        :close-on-click-modal="false"
      >
        <div class="delete_mian">
          <p>成绩发布{{ recordNum }}条记录</p>
        </div>
        <p></p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="recordNumView = false">取 消</el-button>
          <el-button type="primary" @click="recordNumView = false">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { BASEUrl } from "@/utils/request";
import {
  ExamDetail,
  census,
  oneKeyPublishResult,
  publishResult,
} from "@/api/index.js";
import { getExamUserIP, exportAnswer } from "@/api/index.js";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      labelPosition: "right",
      define: true, //定义是单独还是一键发布成绩
      multipleSelection: [], // 多选操作
      getData: [], // 列表数据源
      getIPData: [], // ip列表数据源
      censusArr: [], // 成绩管理统计数据
      currentPage: 1, //  当前页数
      dialogVisible: false, // 成绩发布提示弹窗
      exportVisible: false, // 答题详情弹窗
      recordNumView: false, //  一键发布成绩条数
      recordNum: "", // 一键发布接收的条数
      dialogVisibleArr: false, //一键发布
      PopupIP: false, // IP弹窗
      loading: true,
      btnLoading: false,
      showpageindex: 1, //显示的索引盒子
      pageIndex: parseInt(sessionStorage.getItem("pageIndex")) || 0, //请求的页码数
      pageSize: 10, //每页的条数
      pagesun: "", //一共多少页
      total: 100,
      pagesizesarr: [5, 10, 20, 50, 100],
      examInfo: {}, // 当前操作试卷的信息
      getRow: "",
      isRowName: "", // IP弹窗的名字
      imgArr: [
        {
          text: "总考试人数",
          sum: 0,
          imgUrl: require("@/assets/correcting/pic1.png"),
          num: "人",
        },
        {
          text: "总分",
          sum: 0,
          imgUrl: require("@/assets/correcting/pic2.png"),
          num: "分",
        },
        {
          text: "及格分",
          sum: 0,
          imgUrl: require("@/assets/correcting/pic3.png"),
          num: "分",
        },
        {
          text: "及格人数",
          sum: 0,
          imgUrl: require("@/assets/correcting/pic1.png"),
          num: "人",
        },
        {
          text: "不及格人数",
          sum: 10,
          imgUrl: require("@/assets/correcting/pic1.png"),
          num: "人",
        },
        {
          text: "缺考人数",
          sum: 0,
          imgUrl: require("@/assets/correcting/pic1.png"),
          num: "人",
        },
        {
          text: "最高分",
          sum: 0,
          imgUrl: require("@/assets/correcting/pic4.png"),
          num: "分",
        },
        {
          text: "最低分",
          sum: 0,
          imgUrl: require("@/assets/correcting/pic5.png"),
          num: "分",
        },
      ],
      blodData: "",
      formLabelAlign: {
        department: "", //科室
        rank: "", //职称
        examState: "", //考试状态
        examResults: String(0), //考试成绩
        examines: "", // 批阅状态
        account: "", // 账号查找
        saveModel: "", // 交卷状态
        faceResult: "", // 人脸识别状态
      },
      getDataCondition: {
        account: "", // 账号查找
      },
      value_rank: "",
      departmentArr: [],
      rankArr: [],
      examStateArr: [
        {
          value: "尚未考试",
          label: "尚未考试",
        },
        {
          value: "考试结束",
          label: "考试结束",
        },
        {
          value: "正在考试",
          label: "正在考试",
        },
      ],
      faceResultArr: [
        {
          value: "1",
          label: "自动通过",
        },
        {
          value: "2",
          label: "手动通过",
        },
        {
          value: "0",
          label: "未通过",
        },
      ],
      examResultsArr: [
        {
          label: "升序",
          value: "4",
        },
        {
          label: "降序",
          value: "5",
        },
      ],
      examinesArr: [
        {
          value: "未批阅",
          label: "未批阅",
        },
        {
          value: "已批阅",
          label: "已批阅",
        },
      ],
      formColumns: [
        {
          prop: "CurMode1",
          label: "考试状态",
        },
        {
          prop: "SaveModelArr",
          label: "交卷方式",
          width: "160px",
        },
        {
          // prop: "IsScan",
          prop: "faceResult1",
          label: "扫码登录", // 替换成人脸识别
        },
        {
          prop: "IsRead1",
          label: "批阅状态", // 0 未批阅
        },
      ],
      formIpData: [
        {
          prop: "loginIP",
          label: "IP地址",
        },
        {
          prop: "createTime",
          label: "登录时间",
        },
        {
          prop: "WhetheSource",
          label: "是否用APP考试",
        },
        {
          prop: "source1",
          label: "登录设备",
        },
      ],
      saveModelArr: [
        {
          value: "sys",
          label: "系统",
        },
        {
          value: "Cut",
          label: "切屏",
        },
        {
          value: "normal",
          label: "正常",
        },
        {
          value: "capture",
          label: "截屏",
        },
      ],
      sundflag: false, // 防抖
      achievement: 1, // 发布成绩模式
    };
  },
  props: ["cutcoms"],
  methods: {
    // 表格样式设置
    stateColor({ row, column, rowIndex, columnIndex }) {
      if (row.CurMode1 === "尚未考试" && columnIndex === 8) {
        return "gray";
      } else if (row.CurMode1 === "考试结束" && columnIndex === 8) {
        return "redtwo";
      } else if (row.CurMode1 === "正在考试" && columnIndex === 8) {
        return "green";
      } else if (row.CurMode1 === "超时未答" && columnIndex === 8) {
        return "yellow";
      } else if (row.IsRead1 === "未批阅" && columnIndex === 11) {
        return "gray";
      } else if (row.IsRead1 === "已批阅" && columnIndex === 11) {
        return "green";
      }
    },
    // 返回
    back() {
      if (this.$route.query.trainId) {
        // 培训过来的
        this.$router.push({
          path: this.$route.query.toUrl,
          query: {
            trainId: this.$route.query.trainId,
            toUrl: this.$route.query.toUrl,
            state:'xxqk'
          },
        });
      } else {
        this.cutcoms(0);
      }
      sessionStorage.removeItem("queryObj");
      this.$destroy();
    },
    // chang下拉框查询
    queryChang() {
      this.currentPage = 1;
      this.loading = true;
      sessionStorage.setItem("queryObj", JSON.stringify(this.formLabelAlign)); // 重新刷新缓存当前查询
      this.getResults();
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    handleSelectionChange(val) {
      this.multipleSelection = val; // 批量删除多选状态
    },
    // ip
    userIP(row) {
      if (row.IP != "--") {
        this.PopupIP = true;
        this.getSource(row); // 列表接口
      } else {
        return "";
      }
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.loading = true;
      this.getResults(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.loading = true;
      this.getResults();
    },
    difference: function (beginTime, endTime) {
      var dateBegin = new Date(beginTime);
      var dateEnd = new Date(endTime);
      var dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
      var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
      var leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000)); //计算相差分钟数
      //计算相差秒数
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      let dayDiffStr = "";
      if (dayDiff) {
        dayDiffStr = dayDiff + "天";
      }
      if (hours) {
        dayDiffStr += hours + "小时";
      }
      if (minutes) {
        dayDiffStr += minutes + "分钟";
      }
      if (seconds) {
        dayDiffStr += seconds + "秒";
      }
      if (!dayDiffStr) {
        dayDiffStr = 0;
      }
      return dayDiffStr;
    },
    isNull() {
      // 列表数据的处理
      this.getData.forEach((item) => {
        for (let key in item) {
          if (key == "IsScan" && item[key] == "1") {
            item[key] = "是";
          }
          if (item[key] === "" || item[key] == null || item[key] == undefined) {
            item[key] = "--";
          }
        }
        //答题时间的计算
        item.AlreadyStuCount1 = this.difference(
          item.TestBeginTime,
          item.TestEndTime
        );
        // 考试状态
        if (item.CurMode == 0) {
          item.CurMode1 = "尚未考试";
        } else if (item.CurMode == 1) {
          item.CurMode1 = "正在考试";
        } else if (item.CurMode == 2) {
          item.CurMode1 = "考试结束";
        } else if (item.CurMode == 3) {
          item.CurMode1 = "超时未答";
        }
        // 人脸状态 0：没通过，1：自动通过 2：手动通过
        if (item.faceResult == "--") {
          item.faceResult1 = "无人脸识别";
        } else if (item.faceResult == 0) {
          item.faceResult1 = "未通过";
        } else if (item.faceResult == 1) {
          item.faceResult1 = "自动通过";
        } else if (item.faceResult == 2) {
          item.faceResult1 = "手动通过";
        }
        // 批阅状态
        if (item.IsRead === 0) {
          item.IsRead1 = "未批阅";
        } else if (item.IsRead === 1) {
          item.IsRead1 = "已批阅";
        }
        // 交卷方式
        if (item.SaveModel == "--") {
          item.SaveModelArr = "暂无";
        } else if (item.SaveModel == "sys") {
          if (item.testCount - item.AnswerCount <= 0) {
            // 总题数减去已答题数
            item.SaveModelArr = "系统收卷";
          } else {
            item.SaveModelArr =
              "系统收卷" +
              "，" +
              (item.testCount - item.AnswerCount) +
              "题未答";
          }
        } else if (item.SaveModel == "Cut" || item.SaveModel == "cut") {
          if (item.testCount - item.AnswerCount <= 0) {
            item.SaveModelArr = "切屏收卷";
          } else {
            item.SaveModelArr =
              "切屏收卷" +
              "，" +
              (item.testCount - item.AnswerCount) +
              "题未答";
          }
        } else if (item.SaveModel == "normal") {
          if (item.testCount - item.AnswerCount <= 0) {
            item.SaveModelArr = "正常交卷";
          } else {
            item.SaveModelArr =
              "正常交卷" +
              "，" +
              (item.testCount - item.AnswerCount) +
              "题未答";
          }
        }
        // return item
        // console.log(item.SaveModel, "*****");
      });
      // console.log(this.getData);
    },
    // ip列表接口数据
    async getSource(a) {
      let params = {
        examID: a.ExamID,
        studentUserID: a.UserID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid).hid,
      };
      const Data = await getExamUserIP(params);
      if (Data.status === 200) {
        this.getIPData = Data.data.Data;
        this.isRowName = Data.data.Data[0];
        this.sourceData();
      } else {
        this.$message.error("很抱歉,数据异常!");
      }
      // console.log(Data.data.Data, "IP列表");
    },
    sourceData() {
      this.getIPData.forEach((item) => {
        item.createTime = this.$moment(item.createTime).format(
          "YYYY/MM/DD HH:mm"
        );
        // console.log(item.source);
        if (
          "xxy_phone_android,androidApp,iosApp,xxy_ios,xxy_phone_ios,xxy_pgy,xxy_phone_web_android,xxy_phone_web_ios,xxy_phone".indexOf(
            item.source
          ) > -1
        ) {
          item.WhetheSource = "是";
        } else {
          item.WhetheSource = "否";
        }
        switch (item.source) {
          case null:
            return (item.source1 = "学习云_移动端");
          case "khy":
            return (item.source1 = "考核云_PC端");
          case "xxy_pc":
            return (item.source1 = "学习云_PC端");
          case "xxy_phone":
            return (item.source1 = "学习云_移动端");
          case "xxy_phone_android":
            return (item.source1 = "学习云_安卓端");
          case "xxy_phone_ios":
            return (item.source1 = "学习云_苹果端");
          case "xxy_pgy":
            return (item.source1 = "学习云_苹果端");
          case "xxy_phone_web_ios":
            return (item.source1 = "学习云_苹果移动端");
          case "xxy_phone_web_android":
            return (item.source1 = "学习云_安卓端");
          case "iosApp":
            return (item.source1 = "IOS原生");
          case "xxy_ios":
            return (item.source1 = "IOS原生");
          case "androidApp":
            return (item.source1 = "安卓原生");
        }
      });
    },
    // 成绩管理统计数据
    async getCensus() {
      let params = {
        examID: this.$parent.examInfo.ExamID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const Data = await census(params);
      if (Data.data.Status === 200) {
        this.censusArr = Data.data.Data[0];

        this.imgArr[0].sum = this.censusArr[0].PeopleNumber;
        this.imgArr[1].sum = this.censusArr[0].TotalScore;
        this.imgArr[2].sum = this.censusArr[0].PassScore;
        this.imgArr[3].sum = this.censusArr[0].PassNumber;
        this.imgArr[4].sum = this.censusArr[0].NoPassNumber;
        this.imgArr[5].sum =
          this.censusArr[0].PeopleNumber - this.censusArr[0].ExamPeopleNumber;
        this.imgArr[6].sum = this.censusArr[0].MaxScore;
        this.imgArr[7].sum = this.censusArr[0].MinScore;
        this.imgArr.forEach((item) => {
          if (item.sum === null || item.sum === "") {
            item.sum = 0;
          }
        });
      } else {
        this.$message.error("您的网络已奔溃");
      }

      // console.log(Data.data.Data[0], "统计的数据");
    },
    ccc(row) {
      // console.log(row.UserID, "回去");
    },
    // 批阅试卷
    heExam(row) {
      this.$parent.isread = 0;
      this.$parent.examRow = row;
      sessionStorage.setItem("examRow", row.UserID); // 将试卷ID存入会话存储===>此处是为了禁用未答题打分
      sessionStorage.setItem("queryObj", JSON.stringify(this.formLabelAlign)); // 缓存当前查询
      this.$destroy(); // 摧毁当前页面
      this.cutcoms(2);
    },
    // 发布试卷
    heResults(row) {
      // IsPublish 0未发布成绩 1发布成绩  IsRead 0 未批阅 1已批阅 IsSubjective 是否包含有主观题 0：不包含  ，1：包含
      // console.log(row.IsPublish, row.IsRead);
      // console.log(this.censusArr[0].IsSubjective);
      // let text = "当前考试已经发布过了";
      // if (row.IsPublish == 1) {
      //   text = "当前考试已经发布过了";
      // } else if (row.IsRead == 0 && this.censusArr[0].IsSubjective == 1) {
      //   text = "考试试卷尚未批阅，请批阅后再发布成绩";
      // } else if (row.CurMode1 == "考试结束") {
      //   text = "当前考试已结束";
      // }
      // this.$alert(text, "温馨提示", {
      //   confirmButtonText: "确定",
      //   callback: (action) => {
      //     this.$message({
      //       type: "info",
      //       message: `action: ${action}`,
      //     });
      //   },
      // });
      // return;
      this.define = true;
      this.dialogVisible = true;
      this.getRow = row;
    },
    // 查看试卷
    examView(row) {
      this.$parent.isread = 1;
      this.$parent.examRow = row;
      sessionStorage.setItem("examRow", row.UserID);
      sessionStorage.setItem("queryObj", JSON.stringify(this.formLabelAlign)); // 缓存当前查询
      this.cutcoms(2);
    },
    // 一键确定发布
    async dowmtest() {
      this.sundflag = true;
      let params = {
        examID: this.$parent.examInfo.ExamID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        isAnswerDetail: this.achievement, // 0:只发布成绩，1:成绩+答题详情
      };
      const Data = await oneKeyPublishResult(params);
      if (Data.data.Status === 200) {
        // if (Data.status === 200) {
        this.dialogVisible = false;
        this.recordNum = Data.data.Data.rowsCount;
        this.$message({
          message: "恭喜你，一键发布成功",
          type: "success",
        });
        this.recordNumView = true; // 记录弹窗
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
        this.getResults();
      } else {
        this.sundflag = false;
        this.$message.error("很抱歉,一键发布失败!");
      }
    },
    // 列表数据接口
    async getResults() {
      let queryObj = JSON.parse(sessionStorage.getItem("queryObj"));
      if (queryObj) {
        this.formLabelAlign.department = queryObj.department; // 还原上次操作科室
        this.formLabelAlign.rank = queryObj.rank; // 还原上次操作职称
        this.formLabelAlign.examState = queryObj.examState; // 还原上次操作考试状态
        this.formLabelAlign.examResults = queryObj.examResults; // 还原上次操作考试成绩
        this.formLabelAlign.examines = queryObj.examines; // 还原上次操作批阅状态
        this.formLabelAlign.saveModel = queryObj.saveModel; // 还原上次操作交卷状态
      }
      let params = {
        url: "/api/ksgl/examManager/ExamDetail",
        examID: this.$parent.examInfo.ExamID,
        pageIndex: this.currentPage - 1, // 当前页
        pageShowNumber: this.pageSize, // 条数
        sortType: this.formLabelAlign.examResults, // 考试成绩排序条件
        filterStr: this.formLabelAlign.rank, // 职称查询条件
        StatuStr: this.formLabelAlign.examState, // 考试状态查询条件
        isReadStr: this.formLabelAlign.examines, //批阅状态查询条件
        isDep: this.formLabelAlign.department, // 科室查询条件
        saveModel: this.formLabelAlign.saveModel, // 交卷状态
        SearchStr: this.getDataCondition.account, //搜索框查询条件
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const Data = await ExamDetail(params);
      // this.getData = Data
      if (Data.status === 200) {
        this.rankArr = [];
        this.getData = Data.data.Data.Data;
        this.rankArr = Data.data.Data.PTitleArr;
        console.log(Data.data.Data.count);
        
        this.departmentArr = Data.data.Data.DepartmentArr;
        this.isNull(); // 数据处理
        this.total = Data.data.Data.count;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.$message.error("您的网络已奔溃");
      }
    },
    // 单个成绩发布
    async releaseKey() {
      this.sundflag = true;
      let params = {
        examID: this.getRow.ExamID,
        isAnswerDetail: this.achievement, // 0:只发布成绩，1:成绩+答题详情
        sudentUserID: this.getRow.UserID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      const Data = await publishResult(params);
      if (Data.data.Status === 200) {
        // if (Data.status === 200) {
        this.dialogVisible = false;
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
        this.getResults(); // 列表重新请求
        this.getCensus(); // 卡片区域重新计算
        this.$message({
          message: "恭喜你，发布成功",
          type: "success",
        });
      } else {
        this.sundflag = false;
        this.$message.error("很抱歉,发布失败!");
      }
    },
    // 导出成绩
    exportResults() {
      const link = document.createElement("a");
      link.style.display = "none";
      link.setAttribute("download", this.$parent.examInfo.ExamID + "zip");
      let url = `${BASEUrl.baseurOne}/api/examManage/examResultManager/OutlnExcel/${this.$parent.examInfo.ExamID}`;
      link.href = url;
      document.body.appendChild(link);
      link.click();
      //释放URL对象所占资源
      window.URL.revokeObjectURL(url);
      //用完即删
      // document.body.removeChild(link);
    },
    // 导出所有考生答题详情
    async exportQuestions() {
      let parmas = {
        examID: this.$parent.examInfo.ExamID,
        isAnswer: 1,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      this.btnLoading = true;
      const Data = await exportAnswer(parmas);
      if (Data.status == 200) {
        setTimeout(() => {
          this.State = false; // 弹窗false为导出答题详情确定按钮
          this.exportVisible = true;
          const blob = new Blob([Data.data]);
          let link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.setAttribute(
            "download",
            `${this.$parent.examInfo.ExamName}.zip`
          );
          link.click();
          link = null;
          this.sundflag = false;
          this.State = true;
          this.exportVisible = false;
        }, 500);
      } else if (Data.status == 202) {
        if (!Data.headers["content-disposition"]) {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([Data.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            if (fileReader.result) {
              const msg = JSON.parse(fileReader.result);
              if (msg.status == 202) {
                this.$alert(msg.data, "温馨提示", {
                  confirmButtonText: "了解",
                  type: "warning",
                }).then(() => {
                  setTimeout(() => {
                    this.sundflag = false;
                    this.exportVisible = false;
                  }, 500);
                });
              }
            }
          };
        }
      } else {
        this.$message.error(
          "当前文件过大，后台正在生成文件，请5分钟之后再来下载"
        );
        this.sundflag = false;
        this.State = true;
        this.exportVisible = false;
      }
    },
    // 确定发送去下载
    exportMine() {
      this.sundflag = true;
      setTimeout(() => {
        const blob = new Blob([this.blodData]);
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `${this.$parent.examInfo.ExamName}.zip`);
        link.click();
        link = null;
        this.sundflag = false;
        this.exportVisible = false;
      }, 500);
    },
    // 搜索
    handleQuery() {
      this.loading = true;
      this.showpageindex = 1;
      this.currentPage = 1;
      this.pageSize = 10;
      this.pageIndex = 1;
      if (this.formLabelAlign.account) {
        this.getDataCondition.account = this.formLabelAlign.account;
      } else {
        this.getDataCondition.account = "";
      }
      this.getResults();
    },
    // 重置
    resetForm(formExamin) {
      this.$refs[formExamin].resetFields();
      this.loading = true;
      sessionStorage.removeItem("queryObj"); // 重置内部查询条件
      this.formLabelAlign.account = "";
      this.getDataCondition.account = "";
      this.showpageindex = 1;
      this.currentPage = 1;
      this.pageSize = 10;
      this.getResults();
    },
  },
  created() {
    // console.log("=========", this.$parent.examInfo.ExamName);
    // await this.getCensus();
    // await this.getResults();
  },
  async activated() {
    // 从考试监控进来的
    if (this.$route.query.examID) {
      this.formLabelAlign.examState = "尚未考试";
    }
    this.currentPage = 1;
    await this.getCensus(); // 因为异步组件导致页面会使用keep-alive将页面缓存，此处不能在created调用
    await this.getResults();
  },
  computed: {
    isbtn() {
      return function (item) {
        // CurMode 考试状态0为尚未考试，1为考试中，2为考试结束
        // IsRead  0 是未批阅 1 是已批阅
        if (item.CurMode == 0 || (item.CurMode == 1 && item.IsRead == 0)) {
          return true;
        } else if (item.CurMode == 2 && item.IsRead != 1) {
          // 只要考试结束了，都可以操作
          return false;
        } else if (item.IsPublish == 1) {
          //发布完成绩后，批阅按钮禁用
          return true;
        } else if (item.IsRead == 1 && this.censusArr[0].IsSubjective != 1) {
          // 当前已批阅且没主观阅题
          return true;
        } else {
          return false;
        }
      };
    },
  },
  // activated() {
  //   this.getResults();
  // }
};
</script>
<style lang="scss" scoped>
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.card_box {
  flex-flow: column nowrap;
  align-content: space-around;
  display: flex;
  background: #ffffff;
  height: 196px;
  border-radius: 0px 0px 10px 10px;
  padding: 10px 20px 0px 0px;
  .card_box_span {
    margin-left: 32px;
    font-size: 18px;
  }
  .card_box_item {
    display: flex;
    /*align-content: center;*/
    /*justify-content: space-between;*/
    .card_img {
      width: 205px;
      position: relative;
      img {
        display: block;
        width: 206px;
      }
      p:nth-child(2) {
        position: absolute;
        top: 40px;
        left: 40px;
        font-size: 20px;
        color: #999999;
        font-family: PingFang SC;
        font-weight: bold;
        opacity: 1;
        letter-spacing: 1px;
      }
      p:nth-last-child(1) {
        position: relative;
        top: -90px;
        left: 40px;
        color: #999999;
        font-family: PingFang SC;
        span {
          font-size: 27px;
          color: black;
          font-weight: bold;
        }
        font-size: 14px;
      }
    }
  }
}
.mian {
  margin-top: 32px;
  min-height: 500px;
  background: #ffffff;
  border-radius: 10px;
  ::v-deep .el-form-item__label {
    text-align: center !important;
    margin-left: 18px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  ::v-deep .el-form-item {
    margin-bottom: 0px !important;
  }
  ::v-deep .el-form-item__content {
    margin-left: 120px;
  }
}
.mian_input {
  display: flex;
  flex-wrap: wrap;
  height: 160px;
  padding: 20px 20px 0px 0px;
  border-bottom: 1px solid #f8f8f8;
}
.el-form {
  display: flex;
  flex-wrap: wrap;
  ::v-deep .el-input > .el-input__inner {
    width: 210px;
  }
}
// .query_btn {
//   margin: 0;
//   display: flex;
//   .el-button {
//     width: 88px;
//     height: 40px;
//     margin-left: 140px;
//   }
// }
::v-deep .el-form-item:nth-child(1) {
  .el-form-item__content {
    margin-left: 84px !important;
  }
}
::v-deep .el-form-item:nth-child(2) {
  .el-form-item__content {
    margin-left: 84px !important;
  }
}
::v-deep .el-form-item:nth-child(7) {
  .el-form-item__content {
    margin-left: 20px !important;
  }
}
// ::v-deep .el-form-item:nth-child(n + 3) {
//   width: 285px !important;
// }
.mian_btn {
  padding: 0px 20px 16px 20px;
  display: flex;
  margin: 14px 0px 20px 0px;
  .el-button {
    width: 140px;
    height: 40px;
    color: #ffffff;
    background: #64b5ff;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: 1px;
    margin-right: 24px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
    &:nth-child(3) {
      width: 115px;
    }
    &:nth-child(1) {
      background: #1890ff;
    }
  }
}
// 表单
.mian_form {
  padding: 0px 24px;
  min-height: 560px;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}
.el-button--text {
  font-size: 16px;
}
::v-deep .el-table .redtwo .cell {
  color: #ff0000 !important;
}
::v-deep .el-table .gray .cell {
  color: #aaaaaa !important;
}
::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
}
::v-deep .el-table .yellow .cell {
  color: #ffa200 !important;
}
::v-deep .el-table .green .cell {
  color: #00d254 !important;
}
::v-deep.el-table__row td,
.el-table__row th {
  text-align: center;
}
::v-deep .el-table-column--selection {
  text-align: center;
}
// 弹窗样式
.everywhere {
  ::v-deep .el-dialog {
    width: 441px !important;
    height: 220px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog__header {
    height: 55px;
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    ) !important;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    button:nth-child(1) {
      margin-right: 50px;
    }
  }
  p {
    text-align: center;
    font-size: 16px;
  }
}
.mode_view {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ::v-deep .el-radio__label {
    font-size: 16px;
  }
  > p {
    // text-align: center;
    font-size: 18px !important;
    font-weight: bolder;
    // margin-top: 24px;
    // margin-right: 8px;
  }
}
.p {
  text-align: center;
  font-size: 15px;
  margin-top: 8px;
  font-size: 14px !important;
  color: #ababab;
}
// IP弹窗样式
.ip_view {
  ::v-deep .el-dialog {
    width: 715px !important;
    min-height: 450px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog__header {
    height: 55px;
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    ) !important;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    button:nth-child(1) {
      margin-right: 50px;
    }
  }
  .ip_mian {
    font-size: 16px;
    .exam_name {
      display: flex;
      p:nth-child(1) {
        margin-right: 50px;
      }
      margin-bottom: 4px;
    }
    p {
      margin-bottom: 16px;
    }
  }
}
::v-deep .el-table .cell {
  text-align: center !important;
}
::v-deep.bd {
  border-bottom: 1px solid red;
  color: red;
  height: 20px;
}
.exportView {
  ::v-deep .el-dialog {
    width: 340px !important;
    min-height: 220px !important;
    line-height: 24px;
    border-radius: 5px 5px 0px 0px;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 24px;
    button:nth-child(1) {
      margin-right: 50px;
    }
  }
  ::v-deep .el-dialog__footer {
    padding: 0;
  }
  ::v-deep.el-dialog__header {
    padding: 16px 20px 10px;
  }
  ::v-deep .el-dialog__header {
    height: 55px;
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    ) !important;
  }
  .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.text_sizi {
  font-size: 14px !important;
  display: inline-block;
  margin-left: 2px;
  color: #999999 !important;
}
.search_btn {
  display: flex;
  align-items: center;
  margin-left: 18px;
  margin-bottom: 20px;
  .search_left {
    position: relative;
    i {
      position: absolute;
      top: 0px;
      left: 10px;
      font-size: 20px;
    }

    ::v-deep .el-input__inner {
      width: 360px;
      height: 40px;
      padding-left: 36px;
      &::-webkit-input-placeholder {
        padding-left: 10px;
      }
    }
  }
  .query_btn {
    margin-left: 24px;
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;

      &:nth-child(1) {
        background: #64b5ff;
        color: #ffffffff;
      }
    }
  }
}
</style>
